import { ReactElement } from "react";
import { AppInputProps } from "../../interfaces/ComponentInterfaces";
import { IconWrapper } from "../../customHooks/useIcon";

interface AppDateInputProps extends AppInputProps {
  minDate?: string; // Optional min date
  maxDate?: string; // Optional max date
}

const AppDateInput = ({
  leftIcon: LeftIcon = null,
  rightIcon: RightIcon = null,
  placeholder = "",
  topLabel: TopLabel = null,
  bottomLabel: BottomLabel = null,
  disabled = false,
  name,
  value,
  onChange,
  onBlur,
  error,
  className,
  minDate,
  maxDate,
}: AppDateInputProps): ReactElement => {
  return (
    <div className="w-full">
      {TopLabel && typeof TopLabel === "string" ? (
        <span className="text-sm text-primary-blackMain font-semibold">{TopLabel}</span>
      ) : (
        TopLabel
      )}
      <div
        className={`input-wrapper ${
          error ? "border-red-500" : "border-primary-yellowMain"
        } ${className}`}
      >
        {LeftIcon && (
          <IconWrapper icon={LeftIcon} size={20} className="text-primary-blackLighter" />
        )}
        <input
          className="input-className"
          type="date"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          min={minDate}
          max={maxDate}
        />
        {RightIcon && (
          <IconWrapper icon={RightIcon} size={20} className="text-primary-blackLighter" />
        )}
      </div>
      {BottomLabel && typeof BottomLabel === "string" ? (
        <span className="text-sm text-primary-blackLighter">{BottomLabel}</span>
      ) : (
        BottomLabel
      )}
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </div>
  );
};

export default AppDateInput;
